import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../api.service';
import { IncidentsDocument } from '../shared/models/IncidentsDocument';
import { ResponseFile } from '../shared/models/ResponseFile';
import { UsersSupportDoc } from '../shared/models/UsersSupportDoc';
import { CategoryLan } from '../shared/models/CategoryLan';
import { SecurityDocument } from '../shared/models/SecurityDocument';
import { UsersSupportWrapperVO } from '../shared/models/UsersSupportWrapperVO';
import { TovpilCrudService } from '../utils/tovpil-crud-service';
import { TovpilFilesService } from '../utils/tovpil-files.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { TovpilLanguageService } from '../utils/tovpil-language.service';
import { Constants } from '../shared/vo/Constants';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: "app-tovpil-incidents-review",
  templateUrl: "./tovpil-incidents-review.component.html",
  providers: [MessageService, ConfirmationService],
  styleUrls: ["./tovpil-incidents-review.component.scss"],
})
export class TovpilIncidentsReviewComponent implements OnInit {
  /** COMPONENT */
  lstIncidents?: IncidentsDocument[] = [];
  lstIncidentsFilter?: IncidentsDocument[] = [];
  responseFile?: ResponseFile;
  userSupportDoc?: UsersSupportDoc;
  fromUserId?: string;
  requestType?: string;
  assignedTo?: string;
  showStatus?: string;
  userName?: string;
  mapIncidentsSts = new Map();
  usersSupportWrapper: UsersSupportWrapperVO;
  interval: any;
  filterType: string;
  zonalCoordinations: any = null;
  selectedZonalCoord: any;
  nationalCoordinations: any = null;
  selectedNatioCoordination: any;
  inciRoles: any = null;
  inciTypes: any = null;
  inciSeverities: any = null;
  inciPriorities: any = null;
  statuses: any = [];
  typeIncident: string;

  /** SECURITY */
  token: string;
  security: SecurityDocument;
  storeId: string;
  showNewButton: boolean = false;

  /** LABELS */
  translations: Record<string, string> = {};

  /** OVERLAY  */
  blocked: boolean = false;

  /**  CONSTANT */
  MIME_TYPE_OCTET_STREAM: string = "application/octet-stream";

  /** CREATE FORM */
  dataForm: any;

  /**
   * The constructor function initializes class properties using dependency injection and retrieves a
   * token from query parameters.
   * @param {ApiService} apiService - The `apiService` parameter is a service that allows you to make API
   * calls and interact with external APIs in your Angular application. It is injected into the
   * constructor using Angular's dependency injection system.
   * @param {DatePipe} datepipe - The `DatePipe` is a built-in Angular pipe that is used for formatting
   * dates in templates. It provides various date formats such as short, medium, long, and full. You can
   * use it to transform a date object into a readable string according to the locale rules.
   * @param {ActivatedRoute} route - The `route` parameter in the constructor is of type
   * `ActivatedRoute`, which is a service provided by Angular that gives you access to information about
   * a route associated with a component that is loaded in an outlet. It allows you to access route
   * parameters, query parameters, and other information related to the current
   * @param {Router} router - The `router` parameter in the constructor is an instance of the Angular
   * Router service. It is used for programmatic navigation in Angular applications, allowing you to
   * navigate to different components or routes within your application.
   */
  constructor(
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private confirmationService: ConfirmationService,
    private translationService: TovpilLanguageService,
    private filesService: TovpilFilesService,
    private messageService: MessageService,
    private fb: FormBuilder
  ) {
    this.dataForm = this.fb.group({
      // Default Values
      form_incidentId: new FormControl({ value: null }),
      form_name: new FormControl({ value: "" }),
      form_email: new FormControl({ value: "" }),
      form_zonal_coordination: new FormControl({ value: null }),
      form_national_coordination: new FormControl({ value: null }),
      form_application: new FormControl({ value: null }),
      form_type: new FormControl({ value: null }),
      form_severity: new FormControl({ value: null }),
      form_priority: new FormControl({ value: null }),
      form_review: new FormControl({ value: null }),
      form_description: new FormControl({ value: null }),
      form_file_name: new FormControl({ value: "a" }),
      form_file_src: new FormControl({ value: "" }),
      form_file: new FormControl({ value: "a" }),
      method: new FormControl({ value: null })
    });


    // Suscribe a los cambios del name
    this.dataForm.controls['form_name'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del email
    this.dataForm.controls['form_email'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del zonal coord
    this.dataForm.controls['form_zonal_coordination'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del natio coord
    this.dataForm.controls['form_national_coordination'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del role
    this.dataForm.controls['form_application'].valueChanges.subscribe(value => {
      // console.log(this.dataForm); // Muestra el objeto formData actualizado en la consola
    });

    // Suscribe a los cambios del type
    this.dataForm.controls['form_type'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del severity
    this.dataForm.controls['form_severity'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del priority
    this.dataForm.controls['form_priority'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del resumen
    this.dataForm.controls['form_review'].valueChanges.subscribe(value => {

    });

    // Suscribe a los cambios del description
    this.dataForm.controls['form_description'].valueChanges.subscribe(value => {

    });

    this.dataForm.controls['form_file'].valueChanges.subscribe(value => {

    });

    this.route.queryParams.subscribe((params) => {
      this.token = params["token"];
      this.typeIncident = params["typeIncident"];
    });
  }

  /**
   * The ngOnInit function in TypeScript initializes component properties based on query parameters and
   * calls the getSecurity method if a token is present.
   */
  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.fromUserId = params.fromUserId;
      this.assignedTo = params.assignedTo;
      this.showStatus = params.showStatus;
      this.typeIncident = params.typeIncident;
      this.requestType = params.requestType;
    });
    if (this.token) {
      await this.getSecurity();
      // console.log(this.storeId);
    }
  }

  /**
   * The `ngOnDestroy` function in TypeScript clears an interval if it has been set.
   */
  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  /**
   * The function `getSecurity` retrieves security data based on a provided ID and performs additional
   * operations if the data is successfully retrieved.
   */
  async getSecurity() {
    await this.apiService.findSecurityById({ id: this.token }).then((data) => {
      this.security = data;
      this.getUserById();
      this.getTranslatedLabels();
      this.getIncidentStatus();
      if (this.security) {
        if (this.security.levelId == 'I' || this.security.levelId == 'Z' && this.requestType == 'REQUESTER') {
          this.showNewButton = true;
        }
        if (this.fromUserId) {
          //this.fromUserId = this.security.userId;
        }
        if (this.assignedTo) {
          // this.assignedTo = this.security.userId;
        }
        if (this.storeId) {
          this.storeId = this.security.storeId;
        }

        this.getMapEstatus();
        console.log('inicia...')
        this.blocked = true;
        this.toggleFilter(this.typeIncident ?? 'open', false);
        this.interval = setInterval(() => {
          this.getMapEstatus();
        }, 300000);
      }
    });
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(
        this.security.language,
        this.security.region
      );
      this.translations = this.translationService.getLabels();
      // await this.getLanguages();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      this.messageService.add({
        severity: "warn",
        summary: "Error",
        detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}`,
      });
      // Error al traer labels traducidos
    }
  }

  //Dropdown lists
  //Brings the zonal coordinations from the ApiService
  async getZonalCoordinations() {
    try {
      if (this.zonalCoordinations == null) {
        if (this.security.storeId != null) {

          await this.apiService
            .getLstTreeChildStores(Constants.INTNAL_STOREID, "Y")
            .then((data) => {
              if (this.security.levelId == Constants.INTNAL_LEVELID) {
                this.zonalCoordinations = data.filter((el) => {
                  return el.store.type == "Z";
                });
              } else if (this.security.levelId == Constants.ZONE_LEVELID) {
                this.zonalCoordinations = data.filter((el) => {
                  return el.store.storeId == this.security.storeId;
                });
              }
            });

        }
        else {
          throw new Error("No storeId detected");
        }
      }
    } catch (err) {
      this.handleError(err, "StoreID Error");
    }

  }

  //Brings the national coordinations from the ApiService with the Zonal Coordination's storeId
  async getNationalCoordinations(storeId) {
    try {
      await this.apiService
        .getLstTreeChildStores(
          storeId,
          "Y"
        )
        .then((data) => {
          this.nationalCoordinations = data;
        });
    } catch (error) {
      console.debug("No esta seleccionada ninguna Zona");
    }
  }

  async getIncidentStatus() {
    if (this.inciRoles == null) {
      await this.apiService
        .listCategoryTranslation({
          fieldId: "incidenSts",
          language: this.security.language,
        })
        .then((data) => {

          this.statuses = data.map(e => {
            return {
              label: e.value,
              value: e.valueId
            };
          });
        })
        .catch((error) => {
          console.debug("Error fetching incident roles");
        });
    }
  }

  async getIncidentsDropdowns() {
    //Get Roles
    if (this.inciRoles == null) {
      await this.apiService
        .listCategoryTranslation({
          fieldId: "inciRole",
          language: this.security.language,
        })
        .then((data) => {
          data.shift();
          this.inciRoles = data;
        })
        .catch((error) => {
          console.debug("Error fetching incident roles");
        });
    }

    //Get types
    if (this.inciTypes == null) {
      await this.apiService
        .listCategoryTranslation({
          fieldId: "inciTypes",
          language: this.security.language,
        })
        .then((data) => {
          data.shift();
          this.inciTypes = data;
        })
        .catch((error) => {
          console.debug("Error fetching incident types");
        });
    }

    //Get Severities
    if (this.inciSeverities == null) {
      await this.apiService
        .listCategoryTranslation({
          fieldId: "inciSever",
          language: this.security.language,
        })
        .then((data) => {
          data.shift();
          this.inciSeverities = data;
        })
        .catch((error) => {
          console.debug("Error fetching incidence severities");
        });
    }

    //Get priorities
    if (this.inciPriorities == null) {
      await this.apiService
        .listCategoryTranslation({
          fieldId: "inciPrior",
          language: this.security.language,
        })
        .then((data) => {
          data.shift();
          this.inciPriorities = data
        })
        .catch((error) => {
          console.debug("Error fetching incident priorities");
        });
    }
  }

  // OPTIONS TABLE

  /**
   * The function `selectIncident` navigates to the incident review detail page with specified query
   * parameters.
   * @param {string} [id] - The `id` parameter in the `selectIncident` method is a string that represents
   * the incident ID. It is used to navigate to the incident review details page with the specified
   * incident ID as a query parameter.
   */
  selectIncident(id?: string) {
    this.router.navigate(["incidents/reviewDtl"], {
      queryParams: {
        incidentId: id,
        fromUserId: this.fromUserId,
        assignedTo: this.assignedTo,
        showStatus: this.showStatus,
        requestType: this.requestType,
        typeIncident: this.typeIncident,
        token: this.token,
      },
    });
  }

  /**
   * The `onClickDownloadFile` function downloads a file associated with an incident document using
   * base64 encoding.
   * @param {IncidentsDocument} doc - The `doc` parameter in the `onClickDownloadFile` function is of
   * type `IncidentsDocument`. It contains information about an incident document, such as the incident
   * ID and file name.
   */
  onClickDownloadFile(doc: IncidentsDocument) {
    this.apiService
      .getFileSantoApp({
        nameFile: doc.incidentId + "_" + doc.fileName,
        folderId: "INCIDENTS",
      })
      .then((data) => {
        this.responseFile = data;
        this.downloadFile(doc.fileName, this.responseFile.base64File);
      });
  }

  /**
   * The ` function downloads a file with the given file name and base64 data.
   * @param {string} fileName - The `fileName` parameter is a string that represents the name of the file
   * that will be used when the file is downloaded. For example, if you are downloading a PDF file, the
   * `fileName` could be "document.pdf".
   * @param {string} base64Data - Base64 encoded data representing the file content.
   */
  downloadFile(fileName: string, base64Data: string) {
    const source = `data:${this.MIME_TYPE_OCTET_STREAM};base64,${base64Data}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  }

  // GENERAL FUNCTIONS

  /**
   * The function `` retrieves category language data and populates a map with incident
   * statuses before calling another function to find users by ID.
   */
  getMapEstatus() {
    let lstCat: CategoryLan[];
    this.apiService
      .getCategoryLang({
        language: "es",
        fieldId: "incidenSts",
      })
      .then((categs) => {
        lstCat = categs;
        lstCat.forEach((element) => {
          if (element.descripTo != null) {
            //this.mapIncidentsSts.set(element.fieldVal, element.descripTo);
          } else {
            //this.mapIncidentsSts.set(element.fieldVal, element.descrip);
          }
        });

        //this.findUsersSupportByUserId();
      });
  }

  // MAIN BUTTON
  showOpen: boolean = false;
  showClosed: boolean = false;

  /**
   * The  function toggles between showing open and closed incidents while deactivating the
   * other filter and then calls a method to handle the incident filtering.
   * @param {string} status - The function is used to toggle between showing open and
   * closed items based on the `status` parameter passed to it. If `status` is 'open', it will toggle the
   * `showOpen` property and deactivate the `showClosed` property. If `status` is 'closed
   */
  toggleFilter(status: string, mandatoryChange: boolean) {
    // Activar el filtro seleccionado y desactivar el otro
    this.typeIncident = mandatoryChange || !this.typeIncident ? status : this.typeIncident;

    if (this.typeIncident === 'open') {
      this.showOpen = !this.showOpen;
      this.showClosed = false;  // Desactivar el filtro de cerrados
      this.listAllIncidents('open');
    } else if (status === 'closed') {
      this.showClosed = !this.showClosed;
      this.showOpen = false;  // Desactivar el filtro de abiertos
      this.listAllIncidents('closed');
    }

    this.handleFilterIncident();  // Actualizar los incidentes según los filtros
  }

  /**
   * The function `handleFilterIncident` determines which type of incidents to display based on the
   * `showOpen` and `showClosed` flags.
   */
  handleFilterIncident() {
    if (this.showOpen) {
      console.debug("Abiertos");
      // Si el filtro "Abiertos" está activo, mostrar incidentes abiertos
      this.listAllOpenedIncidents();
    } else if (this.showClosed) {
      console.debug("Cerrados");
      // Si el filtro "Cerrados" está activo, mostrar incidentes cerrados
      this.listAllSolvedIncidents();
    } else if (!this.hasActiveFilters()) {
      console.debug("Todos");
      // Si no hay filtros activos, mostrar todos los incidentes
      this.lstIncidentsFilter = [...this.lstIncidents];
    }
  }

  /**
   * The function hasActiveFilters() returns true if either showOpen or showClosed is true.
   * @returns The `hasActiveFilters()` method is returning a boolean value based on whether
   * `this.showOpen` or `this.showClosed` is true. If either `this.showOpen` or `this.showClosed` is
   * true, the method will return `true`, indicating that active filters are present. Otherwise, it will
   * return `false`.
   */
  hasActiveFilters(): boolean {
    return (
      this.showOpen ||
      this.showClosed
    );
  }

  /**
   * The function `listAllSolvedIncidents` filters and displays all solved incidents based on specified
   * criteria.
   */
  listAllSolvedIncidents() {
    this.blocked = true;
    const solvedIncidents = this.filterIncidentsByStatus(
      this.lstIncidents,
      true,  // Para incidentes resueltos
      this.fromUserId,
      this.assignedTo,
      this.showStatus,
      this.filterType
    );
    console.debug(solvedIncidents);

    this.lstIncidentsFilter = [...solvedIncidents];
    this.blocked = false;
  }

  /**
   * The function `listAllOpenedIncidents` filters and displays all open incidents from a list of
   * incidents.
   */
  listAllOpenedIncidents() {
    this.blocked = true;
    const openedIncidents = this.filterIncidentsByStatus(
      this.lstIncidents,
      false, // Para incidentes abiertos
      this.fromUserId,
      this.assignedTo,
      this.showStatus,
      this.filterType
    );
    console.debug(openedIncidents);
    this.lstIncidentsFilter = [...openedIncidents];
    this.blocked = false;
  }


  /**
   * The function `filterIncidentsByStatus` filters an array of incidents based on various criteria such
   * as status, user ID, assigned user, show status, and filter type.
   * @param {any[]} incidents - The `incidents` parameter is an array of objects representing incidents.
   * Each incident object contains properties like `status`, `userId`, `assignedTo`, and `type`.
   * @param {boolean} isSolved - The `isSolved` parameter is a boolean flag that determines whether to
   * filter incidents based on whether they are solved or closed. If `isSolved` is `true`, the function
   * will filter for incidents that are closed or solved (status 'C' or 'S'). If `isS
   * @param {string} [fromUserId] - The `fromUserId` parameter in the `filterIncidentsByStatus` function
   * is used to filter incidents based on the user ID associated with the incidents. If a `fromUserId` is
   * provided, only incidents that match the specified user ID will be included in the filtered result.
   * If `fromUserId
   * @param {string} [assignedTo] - The `assignedTo` parameter in the `filterIncidentsByStatus` function
   * is used to filter the incidents based on the user to whom the incident is assigned. If a value is
   * provided for `assignedTo`, only the incidents assigned to that specific user will be included in the
   * filtered result. If
   * @param {string} [showStatus] - The `showStatus` parameter in the `filterIncidentsByStatus` function
   * is used to filter the incidents based on their status. If `showStatus` is provided and is equal to
   * "available", then additional filtering logic is applied to include only those incidents where the
   * `assignedTo` field is
   * @param {string} [filterType] - The `filterType` parameter in the `filterIncidentsByStatus` function
   * is used to determine the type of filtering to be applied based on the value provided. If the
   * `filterType` is set to "T", then the filtering will be based on the incident type being "T". If
   * @returns The `filterIncidentsByStatus` function returns an array of incidents that match the
   * specified criteria based on the parameters passed to the function. The filtered array contains
   * incidents that are either closed or solved (based on the `isSolved` parameter), match the
   * `fromUserId` (if provided), match the `assignedTo` (if provided), and match the `showStatus`
   * criteria (if
   */
  filterIncidentsByStatus(
    incidents: any[],
    isSolved: boolean,
    fromUserId?: string,
    assignedTo?: string,
    showStatus?: string,
    filterType?: string
  ): any[] {
    return incidents.filter((incident) => {
      const isClosedOrSolved = isSolved ?
        (incident.status === 'C' || incident.status === 'S') :
        (incident.status !== 'C' && incident.status !== 'S');

      const matchesUser = !fromUserId || fromUserId === incident.userId;
      const matchesAssignedTo = !assignedTo || assignedTo === incident.assignedTo;
      const matchesShowStatus = !showStatus || showStatus !== "available" || (
        incident.assignedTo?.trim() !== "" &&
        (filterType === "T" ? incident.type === "T" : incident.type !== "T")
      );

      return isClosedOrSolved && matchesUser && matchesAssignedTo && matchesShowStatus;
    });
  }

  /**
   * The function `listAllIncidents` retrieves a list of incidents, filters them based on certain
   * criteria, and updates the list accordingly.
   */
  listAllIncidents(type: string) {
    this.blocked = true;
    this.lstIncidents = [];

    this.apiService.listAllIncidentsByStatusZonNat({
      "language": this.security.language,
      "storeId": this.security.storeId,
      "userId": this.security.userId,
      "type": type,
      "reportType": this.requestType,
      "status": this.showStatus

    })
      .then((data) => {
        this.lstIncidentsFilter = data;
        this.blocked = false;
      }).catch(error => {
        this.blocked = false;
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'listIncidents error', detail: error, life: 3000 });
      });
  }

  /**
   * The  function filters incidents based on various criteria and maps the status of
   * each incident.
   * @param {IncidentsDocument[]} incidents - The  function takes an array of
   * `IncidentsDocument` objects as input and filters them based on certain criteria. It then maps over
   * the filtered incidents and updates the `status` property using a mapping from `mapIncidentsSts`.
   * @returns The  function takes an array of `IncidentsDocument` objects as input and
   * filters them based on certain criteria using the `filter` method. It then maps over the filtered
   * incidents and returns a new array of `IncidentsDocument` objects with the `status` property updated
   * using a mapping from `this.mapIncidentsSts`.
   */
  filterIncidents(incidents: IncidentsDocument[]): IncidentsDocument[] {
    return incidents.filter((incident) => {
      return (
        this.filterByUserId(incident) &&
        this.filterByAssignedTo(incident) &&
        this.filterByStatus(incident) &&
        this.filterByType(incident)
      );
    }).map((incident) => {
      return {
        ...incident,
        currDateFormat: this.tovpilUtils.convertStringToDate(incident.currDate)
      };
    });
  }

  /**
   * The function `` maps status descriptions for incidents in an array of
   * IncidentsDocument objects.
   * @param {IncidentsDocument[]} incidents - The `incidents` parameter is an array of
   * `IncidentsDocument` objects.
   * @returns The `` function is returning an array of `IncidentsDocument` objects
   * with updated status descriptions. Each object in the array is being mapped to a new object with the
   * same properties as the original incident, but with the `status` property updated to a new value
   * obtained from the `mapIncidentsSts` map.
   */
  mapStatusDescriptions(incidents: IncidentsDocument[]): IncidentsDocument[] {
    return incidents.map((incident) => {
      return {
        ...incident,
        status: this.mapIncidentsSts.get(incident.status),
      };
    });
  }

  /**
   * The function `filterByUserId` checks if the `fromUserId` matches the `userId` of an incident
   * document.
   * @param {IncidentsDocument} incident - The `incident` parameter in the `filterByUserId` function is
   * of type `IncidentsDocument`.
   * @returns A boolean value is being returned.
   */
  filterByUserId(incident: IncidentsDocument): boolean {
    return !this.fromUserId || this.fromUserId === incident.userId;
  }

  /**
   * The function `filterByAssignedTo` filters incidents based on the assigned user.
   * @param {IncidentsDocument} incident - The `incident` parameter in the `filterByAssignedTo` function
   * is of type `IncidentsDocument`. It represents an incident document with information such as the
   * assigned user, status, description, etc.
   * @returns A boolean value is being returned.
   */
  filterByAssignedTo(incident: IncidentsDocument): boolean {
    return !this.assignedTo || this.assignedTo === incident.assignedTo;
  }

  /**
   * The function `filterByStatus` filters incidents based on status and type criteria.
   * @param {IncidentsDocument} incident - The `incident` parameter is of type `IncidentsDocument`, which
   * likely represents a document or object containing information about an incident. The function
   * `filterByStatus` takes this incident object as input and performs certain checks based on the values
   * of `showStatus`, `filterType`, and properties of the
   * @returns The filterByStatus function returns a boolean value.
   */
  filterByStatus(incident: IncidentsDocument): boolean {
    if (this.showStatus === "available") {
      const statusCheck =
        incident.status !== "L" || incident.assignedTo !== null;
      const typeCheck =
        (this.filterType === "T" && incident.type === "T") ||
        (this.filterType === "I" && incident.type !== "T");
      return statusCheck || typeCheck;
    }
    return true;
  }

  /**
   * The function filterByType checks if the incident status is not 'C' when either fromUserId or
   * assignedTo is not present.
   * @param {IncidentsDocument} incident - The `incident` parameter is of type `IncidentsDocument`, which
   * likely represents a document or object containing information about an incident. The function
   * `filterByType` checks if either `fromUserId` or `assignedTo` properties are not present, or if the
   * incident status is not equal to '
   * @returns The filterByType method is returning a boolean value.
   */
  filterByType(incident: IncidentsDocument): boolean {
    return !(this.fromUserId || this.assignedTo) || incident.status !== "C";
  }

  /**
   * The function retrieves user support data based on the user ID and sets a
   * filter type if the support type is 'I' or 'T', then proceeds to list all incidents.
   */
  /** ACR findUsersSupportByUserId() {
     this.filterType = null;
     this.apiService
       .findUsersSupportByUserId({
         userId: this.security.userId,
       })
       .then((data) => {
         this.usersSupportWrapper = data;
         if (this.usersSupportWrapper.status == "OK") {
           if (
             this.usersSupportWrapper.lstUsersSupport[0].type == "I" ||
             this.usersSupportWrapper.lstUsersSupport[0].type == "T"
           ) {
             this.filterType = this.usersSupportWrapper.lstUsersSupport[0].type;
           }
         }
         //check list
         this.listAllIncidents();
       });
   }*/

  /**
   * The `exportExcel` function exports data from `coordinationCatalogList` to an Excel file.
   */
  exportExcel() {
    try {
      if (this.lstIncidents === null) {
        this.handleError("Coordinación", "No existe información para procesar");
      } else if (this.lstIncidents.length < 1) {
        this.handleError("Coordinación", "Lista Vacia");
      } else {
        const filteredJSON = this.lstIncidents.map((item) => ({
          ID_INCIDENTE: item ? item?.incidentId || "S/N" : "S/N",
          FECHA: item ? item?.currDate || "S/N" : "S/N",
          NOMBRE: item ? item?.personName || "S/N" : "S/N",
          TITULO: item ? item?.subject || "S/N" : "S/N",
          ZONA: item ? item?.zonCoord || "S/N" : "S/N",
          NACIONAL: item ? item?.natioCoord || "S/N" : "S/N",
          ASIGNADO: item ? item?.assignedTo || "S/N" : "S/N",
          ESTATUS: item ? item?.status || "S/N" : "S/N",
        }));
        this.filesService.tovpilExportXLSX(filteredJSON, "listIncidents_");
      }
    } catch (error) {
      console.error("An error occurred while exporting to Excel:", error);
      this.handleError(
        "FII List",
        "Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde."
      );
    }
  }

  /**
   * The exportPdf function exports data from the coordinationCatalogList array to a PDF file.
   */
  exportPdf() {
    try {
      if (this.lstIncidents === null) {
        this.handleError("Coordinación", "No existe información para procesar");
      } else if (this.lstIncidents.length < 1) {
        this.handleError("Coordinación", "Lista Vacia");
      } else {
        const filteredJSON = this.lstIncidents.map((item) => ({
          ID_INCIDENTE: item ? item?.incidentId || "S/N" : "S/N",
          FECHA: item ? item?.currDate || "S/N" : "S/N",
          NOMBRE: item ? item?.personName || "S/N" : "S/N",
          TITULO: item ? item?.subject || "S/N" : "S/N",
          ZONA: item ? item?.zonCoord || "S/N" : "S/N",
          NACIONAL: item ? item?.natioCoord || "S/N" : "S/N",
          ASIGNADO: item ? item?.assignedTo || "S/N" : "S/N",
          ESTATUS: item ? item?.status || "S/N" : "S/N",
        }));

        const keysArray = filteredJSON.map((item) => Object.keys(item));
        const valuesArray = filteredJSON.map((item) => Object.values(item));

        this.filesService.tovpilExportPDF(
          keysArray[0],
          valuesArray,
          "listIncidents_"
        );
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.handleError(
        "FII List",
        "Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde."
      );
    }
  }

  /**
   * The function checks if a given string is empty or contains only whitespace characters.
   * @param {string} [name] - The function `` takes an optional parameter `name` of type
   * string. It checks if the `name` is null, empty, contains only whitespace, or is equal to the string
   * 'null'. If any of these conditions are met, the function returns `true`, indicating that the file
   * @returns The function `` returns a boolean value indicating whether the `name`
   * parameter is empty, null, or contains only whitespace characters.
   */
  fileNameIsEmpty(name?: string): boolean {
    return !name || !name.trim();
  }

  /**
   * The handleError function handles errors by displaying a message and navigating back.
   * @param {string} summary - Summary is a brief description or title of the error that occurred. It
   * helps to provide a quick overview of what went wrong.
   * @param {string} detail - The `detail` parameter in the `handleError` function is a string that
   * provides additional information or details about the error that occurred. It is meant to give more
   * context or explanation about the error to help users understand what went wrong.
   */
  handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: "error",
      summary: summary,
      detail: detail,
      life: 5000,
    });
  }

  /* The above TypeScript code defines a function named `goBack` that closes the current window when
  called. */
  goBack() {
    window.close();
  }

  // CRUD
  displayModal: boolean = false;

  /**
   * The function `onDisplayCreateModal` sets the `displayModal` property to true.
   */
  async onDisplayCreateModal() {
    // let user = await this.apiService
    console.debug(this.userName);
    this.dataForm.patchValue({
      method: "CREATE",
      form_file: "",
      form_file_name: "",
      form_name: this.userName,
    })
    this.getZonalCoordinations();
    this.getIncidentsDropdowns();

    this.displayModal = true;
  }


  /**
  * The function `onDisplayUpdateeModal` sets the `displayModal` property to true.
  */
  async onDisplayUpdateModal(incidentId: string) {
    let doc: IncidentsDocument;
    let natioCoord = "";
    let request = {
      incidentId: incidentId,
      method: "GET"
    };
    await this.getZonalCoordinations();
    await this.getIncidentsDropdowns();

    doc = await this.apiService.getCreateUpdateDeleteIncidents(request);

    let zonCoordUpload = this.zonalCoordinations.filter(e => {
      return (e.store.storeId == doc.zonCoord) || (e.store.descri == doc.zonCoord);
    });
    //no validar la zona al editar
    if (zonCoordUpload.length > 0) {
      //   this.handleError(
      //    "Incidents List",
      //    "No existe la zona de coordinacion"
      //   );
      // }

      await this.getNationalCoordinations(zonCoordUpload[0].store.storeId);
      // console.log(this.nationalCoordinations);
      natioCoord = this.nationalCoordinations.filter(e => {
        return (e.store.storeId == doc.natioCoord) || (e.store.descri == doc.natioCoord);
      })
    }
    let applicationUpload = this.inciRoles.filter(e => {
      return e.valueId == doc.funcAppli;
    });

    let typeUpload = this.inciTypes.filter(e => {
      return e.valueId == doc.type;
    });

    let prioUpload = this.inciPriorities.filter(e => {
      return e.valueId == doc.priority;
    });

    let severityUpload = this.inciSeverities.filter(e => {
      return e.valueId == doc.severity;
    });

    this.dataForm.patchValue({
      method: "UPDATE",
      form_incidentId: doc.incidentId,
      form_name: doc.personName,
      form_email: doc.email,
      form_review: doc.subject,
      form_description: doc.body,
      form_file_name: doc.fileName,
      form_file: doc.base64File,
      form_zonal_coordination: zonCoordUpload[0] != null ? zonCoordUpload[0] : "",
      form_national_coordination: natioCoord[0] != null ? natioCoord[0] : 0,
      form_application: applicationUpload[0],
      form_type: typeUpload[0],
      form_priority: prioUpload[0],
      form_severity: severityUpload[0]
    });
    this.displayModal = true;
  }


  /**
   * The `onCloseCreateModal` function closes a modal and resets a form in TypeScript.
   */
  onCloseCreateModal() {
    this.displayModal = false;
    this.dataForm.reset();
    this.dataForm.patchValue({ form_file: "", form_file_name: "" });
  }

  /**
   * The `onSave` takes the data from `dataForm` and save the record, the function can upload or create a new record
   */
  onSave() {
    let request: IncidentsDocument;
    try {
      if (this.dataForm.get('method').value == "CREATE") {
        request = {
          personName: this.dataForm.get('form_name').value,
          email: this.dataForm.get('form_email').value,
          userId: this.security.userId,
          zonCoord: this.dataForm.get('form_zonal_coordination').value.store.storeId,
          natioCoord: this.dataForm.get('form_national_coordination')?.value?.store?.storeId,
          funcAppli: this.dataForm.get('form_application').value.valueId,
          type: this.dataForm.get('form_type').value.valueId,
          severity: this.dataForm.get('form_severity').value.valueId,
          priority: this.dataForm.get('form_priority').value.valueId,
          subject: this.dataForm.get('form_review').value,
          body: this.dataForm.get('form_description').value,
          base64File: this.dataForm.get('form_file').value,
          method: this.dataForm.get('method').value,
          fileName: this.dataForm.get('form_file_name').value
        }
      }
      else if (this.dataForm.get('method').value == "UPDATE") {
        request = {
          incidentId: this.dataForm.get("form_incidentId").value,
          personName: this.dataForm.get('form_name').value,
          email: this.dataForm.get('form_email').value,
          zonCoord: this.dataForm.get('form_zonal_coordination').value.store.storeId,
          natioCoord: this.dataForm.get('form_national_coordination')?.value?.store?.storeId,
          funcAppli: this.dataForm.get('form_application').value.valueId,
          type: this.dataForm.get('form_type').value.valueId,
          status: "N",
          severity: this.dataForm.get('form_severity').value.valueId,
          priority: this.dataForm.get('form_priority').value.valueId,
          subject: this.dataForm.get('form_review').value,
          body: this.dataForm.get('form_description').value,
          base64File: this.dataForm.get('form_file').value,
          method: this.dataForm.get('method').value,
          fileName: this.dataForm.get('form_file_name').value
        }
      }
    } catch (error) {
      console.debug("No se estan proporcinoando todos los datos correctos");
      this.handleError(this.translations.lbl_bad_request, error);
    }


    this.apiService.getCreateUpdateDeleteIncidents(request).then(data => {
      if (data.statusMsg != "OK") {
        this.messageService.add({ severity: 'warn', summary: ` Error`, detail: data.errorMessage, life: 5000 });
      }
      else {
        this.dataForm.reset();
        this.listAllIncidents(this.typeIncident);
        this.displayModal = false;
      }

    }).catch(e => {
      console.debug(e);
    });
  }



  uploadEvidence(e) {
    let file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    this.dataForm.patchValue({ form_file_name: file.name });

    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    let array = reader.result.split(",");
    this.dataForm.patchValue({ form_file_src: array[1] });
  }


  onFileSelected(event: any) {
    const file = event.target.files[0];
    // console.log(file);
    this.convertToBase64(file);
  }

  convertToBase64(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (element) => {
      let base64 = reader.result as string;
      base64 = (base64.split(',')[1]);
      this.dataForm.patchValue({
        form_file: base64,
        form_file_name: file.name
      });
    };

    // console.log(this.dataForm);
  }

  /**
   * The function `_assigNationalCoordination` checks the Zonal Coordination's storeId and asign the options to national coordination dropdwon
   */
  _assigNationalCoordination(event) {
    let storeId = event.value.store.storeId;
    this.dataForm.patchValue({
      form_zonal_coordination: event.value
    })
    this.getNationalCoordinations(storeId);
  }

  /**
  * The function `deleteRecord` takes the `incidentId` and deletes the record.
  */
  async deleteRecord(incidentId: string) {
    let doc: IncidentsDocument;
    let request = {
      method: "GET",
      incidentId: incidentId
    }
    doc = await this.apiService.getCreateUpdateDeleteIncidents(request);
    try {
      this.confirmationService.confirm({
        message: `${this.translations.lbl_confirm} ${this.translations.lbl_delete_record} ${doc.incidentId} - ${doc.subject}, ${this.translations.lbl_wish_to_continue}?`,
        header: this.translations.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        acceptButtonStyleClass: "p-button-danger",
        rejectButtonStyleClass: "p-button-info",
        acceptLabel: this.translations.lbl_yes,
        rejectLabel: this.translations.lbl_no,
        accept: async () => {
          doc.method = "DELETE";
          // console.log(doc);
          this.apiService.getCreateUpdateDeleteIncidents(doc)
            .then(data => {
              console.debug("OK");
              this.listAllIncidents(this.typeIncident);
            })
            .catch(e => {
              console.debug("Error al eliminar el registro " + e);
              this.messageService.add({ severity: 'warn', summary: 'Error al eliminar', detail: e, life: 5000 });
            });

        }
      });
    } catch (confirmationError) {
      console.error("An error occurred while confirming deletion:", confirmationError);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al confirmar la eliminación', life: 5000 });
    }
  }
  async getUserById() {

    await this.apiService.getUserById({ "login": this.security.userId }).then(
      data => {
        if (data) {
          this.userName = data.name + " " + data.lastName;
        }
      });

  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'J': // Rechazado
        return 'danger'; // Rojo
      case 'C': // Cerrada
        return 'success'; // Verde
      case 'E': // Asignada a Experto
        return 'info'; // Azul
      case 'L': // Liberada para resolver por Voluntarios
        return 'warning'; // Amarillo
      case 'N': // Nueva incidencia
        return 'primary'; // Azul claro
      case 'S': // Solucionada
        return 'success'; // Verde
      default:
        return 'secondary'; // Gris, por si acaso
    }
  }

}